import { createLabeledMessages } from '../../../messageUtils';
const confirm = {
    formMessage: 'Chystáte sa opustiť stránku s prebiehajúcim formulárom. Po stlačení tlačidla "$t(confirm:continue)"formulár opustíte a vyplnené údaje sa stratia..',
    formTitle: 'Rozpracovaný formulár',
    leaveTitle: 'Chcete opustiť stránku?',
    title: 'Ste si istý/á?',
    continue: 'Pokračovať',
    cancel: 'Zrušiť',
    doYouWantToLeave: 'Naozaj chcete opustiť stránku?',
    changesWontBeSaved: 'Zadané údaje a vykonané zmeny sa neuložia.',
    leaveThePage: 'Opustiť stránku',
    stayOnThePage: 'Zostať na stránke'
};
export default Object.assign({}, confirm, createLabeledMessages(confirm));
